import { render, staticRenderFns } from "./TheAnsweringMessage.vue?vue&type=template&id=d1049afa"
import script from "./TheAnsweringMessage.vue?vue&type=script&lang=js"
export * from "./TheAnsweringMessage.vue?vue&type=script&lang=js"
import style0 from "./TheAnsweringMessage.vue?vue&type=style&index=0&id=d1049afa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports